import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MetaTagDefinitionData, MetaTagType} from "../../catalogue/meta-tag/meta-tag.data";

@Injectable()
export class DocketSelectorEntityModel extends EntityModel<MetaTagDefinitionData> {

    constructor(injector: Injector) {
        super(injector, MetaTagDefinitionData);
    }

    override getResourceName(): string {
        return "meta-tag-definition";
    }

    override getResource(): string {
        return "docket-selector";
    }

    protected override onNewEntity(entityData: MetaTagDefinitionData): void {
        super.onNewEntity(entityData);
        entityData.type = MetaTagType.DOCKET_SELECTOR;
    }
}
